import { Header as StyledHeader } from './Header.styles.js';

import Icon from '../../components/Icon';

const Header = () => (
	<StyledHeader>
		<StyledHeader.Title>
			<Icon name="amigo-logo" marginRight={4} customClass="header-logo"  />

			SignBox
		</StyledHeader.Title>
	</StyledHeader>
);

export default Header;
